/**
 * @param {string | Date} date
 * @returns ISO-8601 Date YYYY-MM-DD or undefined if date is invalid
 */
export const dateToYYYYMMDD = (date: string | Date): string | undefined => {

  try {

    const dateObj = date instanceof Date ? date : new Date(date);

    if (isNaN(dateObj.getTime())) {

      return undefined;
    
    }

    return dateObj.toISOString().split('T')[0];
  
  } catch (e) {

    return undefined;
  
  }

};
